<template>
  <div>
    <banner-swipe :banners="banners" />

    <service-nav :services="services" />

    <ad-panel :list="newyearAds" @on-item-click="$parent.takeNewyearCoupons" />

    <coupon-panel />

    <!-- <ad-panel :list="ads" /> -->

    <live-floor />

    <product-floor />

    <shop-floor />

    <product-panel />
  </div>
</template>

<script>
import { domainNameConstant } from '@/config/domainnameconstant'
import BannerSwipe from './components/BannerSwipe'
import ServiceNav from './components/ServiceNav'
import LiveFloor from './live-floor'
import ProductFloor from './product-floor'
import ShopFloor from './shop-floor'
import AdPanel from './ad-panel'
import CouponPanel from './coupon-panel'
import ProductPanel from './product-panel'
import { getBanners } from '@/api/banner'

export default {
  name: 'MainContent',
  components: {
    BannerSwipe,
    ServiceNav,
    LiveFloor,
    ProductFloor,
    ShopFloor,
    AdPanel,
    CouponPanel,
    ProductPanel
  },
  data() {
    return {
      banners: [],
      services: [
        { to: '/puhui/services/member', icon: require('@/assets/images/puhui/s1.jpg') },
        { to: '/puhui/services/staff', icon: require('@/assets/images/puhui/s2.jpg') },
        { to: '/puhui/services/shehuifuwu', icon: require('@/assets/images/puhui/s3.jpg') },
        { to: '/puhui/services/financial', icon: require('@/assets/images/puhui/s4.jpg') }
      ],
      newyearAds: [`//${domainNameConstant}/h5/mammon.gif`]
      // ads: [require('@/assets/images/puhui/jd.png'), require('@/assets/images/puhui/yd.png')]
    }
  },
  mounted() {
    getBanners().then(res => (this.banners = res.data.rows))
  }
}
</script>
